import { Autocomplete, Checkbox, FormControlLabel, TextField } from "@mui/material";
import { FormFieldController } from "@src/appV2/PlacementCandidates/components/FormFieldController";
import { type Control, useWatch } from "react-hook-form";

import { type RequirementMappingFormValues } from "../types";

interface WorkplaceTypesFieldProps {
  control: Control<RequirementMappingFormValues>;
  workplaceTypeOptions: string[];
  isLoading: boolean;
}

export function WorkplaceTypesField(props: WorkplaceTypesFieldProps) {
  const { control, workplaceTypeOptions, isLoading } = props;
  const allWorkplaceTypes = useWatch({
    control,
    name: "allWorkplaceTypes",
  });

  return (
    <>
      <FormFieldController
        name="allWorkplaceTypes"
        control={control}
        label=""
        sx={{ mb: 2 }}
        render={(field) => (
          <FormControlLabel
            control={
              <Checkbox
                checked={field.value}
                onChange={(event) => {
                  field.onChange(event.target.checked);
                }}
                onBlur={field.onBlur}
              />
            }
            label="All workplace types"
          />
        )}
      />

      {!allWorkplaceTypes && (
        <FormFieldController
          required
          name="workplaceTypes"
          control={control}
          label="Workplace Types"
          sx={{ mb: 2 }}
          render={(field) => (
            <Autocomplete
              multiple
              options={workplaceTypeOptions}
              loading={isLoading}
              value={field.value}
              // @ts-expect-error - field not typed correctly
              // FIXME: Automatically disabled during ESLint config update
              renderInput={(params) => <TextField {...params} error={Boolean(field.error)} />}
              onChange={(_, newValue) => {
                field.onChange(newValue);
              }}
              onBlur={field.onBlur}
            />
          )}
        />
      )}
    </>
  );
}
